import { APIUrls } from "../../Constants/ApiUrls";
import { IPatient } from "../../Models/IPatient";
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const PatientController = {
  UpdatePatientMeta: async (
    patientId: number,
    patientCard: any,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.PATIENTS.PATIENTS_UPDATE_META_URL.replace(
      ":patientId",
      patientId.toString()
    );
    request.method = "PUT";
    request.disableTimeout = true;
    request.payload = { patientCard: JSON.stringify(patientCard) };

    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  UpdatePatient: async (
    patient: IPatient,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.PATIENTS.PATIENTS_UPDATE_URL.replace(
      ":patientId",
      patient.id.toString()
    );
    request.method = "PUT";
    request.payload = patient;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  GetPatients: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.PATIENTS.PATIENTS_URL;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default PatientController;
